import api from './api';
import { API_ENDPOINTS } from '../constants/config';
import { getApiErrorMessage } from '../utils/errorHandler';

const systemTypeService = {
  // Used by ticket/contract modals
  async getProblemMapping() {
    try {
      const res = await api.get(API_ENDPOINTS.SYSTEM_TYPES_PROBLEM_MAPPING);
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  // In admin settings page fetches all active system types and their problems
  async getAll() {
    try {
      const res = await api.get(API_ENDPOINTS.SYSTEM_TYPES);
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  async create(name) {
    try {
      const res = await api.post(API_ENDPOINTS.SYSTEM_TYPES, { name });
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  async rename(id, name) {
    try {
      const res = await api.put(API_ENDPOINTS.SYSTEM_TYPE_DETAIL(id), { name });
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  async remove(id) {
    try {
      const res = await api.delete(API_ENDPOINTS.SYSTEM_TYPE_DETAIL(id));
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  async addProblem(systemTypeId, name) {
    try {
      const res = await api.post(
        API_ENDPOINTS.SYSTEM_TYPE_PROBLEMS(systemTypeId),
        { name }
      );
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  async removeProblem(systemTypeId, problemId) {
    try {
      const res = await api.delete(
        API_ENDPOINTS.SYSTEM_TYPE_PROBLEM_DETAIL(systemTypeId, problemId)
      );
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  },

  // Restores system types and problem types
  async restoreDefaults() {
    try {
      const res = await api.post(API_ENDPOINTS.SYSTEM_TYPES_RESTORE_DEFAULTS);
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: getApiErrorMessage(error) };
    }
  }
};

export default systemTypeService;